import React, { useState } from "react";
import { useIntl } from "react-intl";
import { ParagraphOutputCustom } from "@/model/paragraph";
import { formatJSON, isValidJSON } from "@/util/stringUtil";
import { CodeEditor } from "@/component/input";
import Tooltip from "@/component/Tooltip";
import { CloseIcon } from "@/assets/svgs/icons";

import { ParagraphInputsProps } from "../model";


const ParagraphOutputCustomCardInputs: React.FC<ParagraphInputsProps<ParagraphOutputCustom>> = (props) => {
    const { paragraph, onChange } = props;

    const intl = useIntl();

    const [inValid, setInValid] = useState<boolean>(false);

    const onChangeValue = (value: string) => {
        const isJSON = isValidJSON(value);
        setInValid(!isJSON);
        if (isJSON) {
            onChange({
                ...paragraph,
                data: JSON.parse(value)
            });
        }
    };

    return (
        <div className="col-span-2 flex flex-col gap-1.5">
            <div className="h-6 flex items-center field-label">
                {intl.formatMessage({ id: "i04032" })}
            </div>
            <div className="relative">
                {inValid && (
                    <Tooltip placement="top"
                             message={intl.formatMessage({ id: "i04033" })}
                    >
                        <div className="absolute -left-5 bg-point-red rounded-[2px] z-50">
                            <CloseIcon className="size-3 text-white" />
                        </div>
                    </Tooltip>
                )}
                <CodeEditor mode="json"
                            height="250px"
                            defaultValue={formatJSON(paragraph.data)}
                            inValid={inValid}
                            invalidMessage={intl.formatMessage({ id: "i04033" })}
                            onChange={onChangeValue}
                />
            </div>
        </div>
    );
};

export default ParagraphOutputCustomCardInputs;
